function topMenu() {
  menuScroll();
  mobileMenu();
}

function menuScroll() {
  let _scrollLast = 0;
  const buffer = 150;
  const tolerance = 15;
  const $menu = $(".topmenu-fixed"); // 建議快取選擇器

  $(window).on("scroll", () => {
    let _scrollTop = $(window).scrollTop();
    let _allBottom = $("body").height() - $(window).height() - buffer;

    // 1. 基礎邊界檢查 (保留您原本的)
    if (_scrollTop < 0 || _scrollTop > _allBottom) {
      return false;
    }

    // ▼▼▼ 新增：跨檔案溝通攔截器 ▼▼▼
    // 檢查 body 是否有由 GSAP 掛上的 class
    if ($("body").hasClass("is-pinning")) {
      // 如果正在 Pinning 動畫中...

      // 1. 強制移除顯示 class (確保選單隱藏)
      $menu.removeClass("is-show");

      // 2. 關鍵：更新 _scrollLast，防止離開 Pin 區瞬間發生跳動
      _scrollLast = _scrollTop;

      // 3. 直接中斷函式，不執行後面的邏輯
      return;
    }
    // ▲▲▲ 新增結束 ▲▲▲


    // 以下是您原本的邏輯 (完全不用動)
    if (_scrollTop > buffer) {
      // 計算與上次滾動的差距
      let delta = _scrollTop - _scrollLast;

      if (Math.abs(delta) > tolerance) {
        if (delta > 0) {
          $menu.removeClass("is-show");
        } else {
          $menu.addClass("is-show");
        }
      }

    } else {
      $menu.removeClass("is-show");
    }

    _scrollLast = _scrollTop;
  }).trigger("scroll");
  // =======

  // hover與下拉選單 
  let hideTimer;
  $('nav li.group').each(function (index) {
    // this = 當前 li.group
    $(this).on('mouseenter', function () {
      clearTimeout(hideTimer);
      const $target = $(this).find('ul.dropdown');

      $target
        .removeClass('hidden')
        .addClass('block');

      hideTimer = setTimeout(() => {
        $target.removeClass('opacity-0').addClass('opacity-100');
      }, 10); // 稍微延遲
    })
      .on('mouseleave', function () {
        const $target = $(this).find('.dropdown');

        $target
          .removeClass('opacity-100')
          .addClass('opacity-0');

        hideTimer = setTimeout(() => {
          $target.removeClass('block').addClass('hidden');
        }, 300); // 👈 對應 Tailwind transition 時間
      });
  });
  // =======
}

function mobileMenu() {
  // 漢堡條點擊事件
  $('.burger-box .button').on('click', function () {
    $('.mobile-menu').toggleClass('active');
  });

  $('.close-btn').on('click', function () {
    $('.mobile-menu').removeClass('active');
    console.log('aaaaa');

  });
}

export { topMenu };